//
// Generated class DLProxyPaymentTransaction
//

/// <reference path="DLProxyPaymentTransaction_ManagedObject.ts" />

class DLProxyPaymentTransaction extends DLProxyPaymentTransaction_ManagedObject
{

}
